import { initializeApp } from 'firebase/app'
import {
  getFirestore,
  collection,
  getDocs,
  addDoc,
  deleteDoc,
  serverTimestamp,
  doc,
  orderBy,
  limit,
  onSnapshot,
  query,
} from 'firebase/firestore'
import {
  getAuth,
  createUserWithEmailAndPassword,
  updateProfile,
  onAuthStateChanged,
  signInWithEmailAndPassword,
  signOut,
} from 'firebase/auth'
import {
  getDownloadURL,
  ref,
  updateMetadata,
  uploadBytes,
  getStorage,
} from 'firebase/storage'

const firebaseConfig = {
  apiKey: 'AIzaSyACncGaW3T38DRqZrXCi1zzXfcxWVYmGM0',
  authDomain: 'notice-app-c88cf.firebaseapp.com',
  projectId: 'notice-app-c88cf',
  storageBucket: 'notice-app-c88cf.appspot.com',
  messagingSenderId: '912694468127',
  appId: '1:912694468127:web:487b5fdc62f8a389137f2a',
  measurementId: 'G-XNLZP074BB',
}
// init firebase app
const app = initializeApp(firebaseConfig)

// init services
const db = getFirestore(app)
const auth = getAuth()
const storage = getStorage(app)

async function uploadFiletoFirebase(file, fileName) {
  try {
    // Upload image.
    const fileRef = ref(storage, `files/${fileName}`)
    const uploadFile = await uploadBytes(fileRef, file)

    // Create file metadata.
    const newMetadata = {
      contentType: uploadFile.metadata.contentType,
    }

    await updateMetadata(fileRef, newMetadata)

    // Get the image URL.
    const url = await getDownloadURL(fileRef)
    return url
  } catch (error) {
    console.log(error)
  }
}

export {
  db,
  auth,
  storage,
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
}
